// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"
import Content from "../../content/about-us/mission.json"

import { colors } from "../../utils/theme/colors"
import { fontWeights } from "../../utils/theme/font-weights"

const Paragraph = ({ text }) => (
  <p
    sx={{
      color: colors.white,
      fontSize: `0.94rem`,
    }}
  >
    {text}
  </p>
)

const Mission = ({ langKey }) => {
  const { title, paragraph1, paragraph2, paragraph3 } = Content[langKey]

  return (
    <div
      sx={{
        backgroundColor: colors.code.secondary,
        width: [`100%`, `100%`, `704px`, `704px`],
        height: [null, null, `365px`, `365px`],
        pt: "50px",
        pl: "158px",
        alignSelf: [null, null, `flex-end`, `flex-end`],
        zIndex: 0,
        position: "relative",
        right: "95px",
        bottom: "-40px",
      }}
    >
      <div sx={{ width: "490px", pl: "55px" }}>
        <h2
          sx={{
            color: colors.white,
            fontWeight: fontWeights.black,
          }}
        >
          {title}
        </h2>
        <Paragraph text={paragraph1} />
        <Paragraph text={paragraph2} />
        <Paragraph text={paragraph3} />
      </div>
    </div>
  )
}

export default Mission
